Ext.ns('mx.comp');

mx.comp.FormPanel = Ext.extend(Ext.FormPanel, {
    layout: 'mx-form',
    destroyed: false,
    readOnly: false,
    setReadOnly: function(v, except) {
        except = except || [];
        this.readOnly = v;
        var fn = function(c) {
            if (!c.rendered && Ext.isArray(c.items)) {
                c.on(
                    'render',
                    function() {
                        fn(this);
                    },
                    c
                );
            } else if (c.items instanceof Ext.util.MixedCollection) {
                if (except.indexOf(c.name) < 0) {
                    c.items.each(fn);
                }
            } else {
                if (except.indexOf(c.name) < 0) {
                    if (v) {
                        c.disable();
                    } else {
                        c.enable();
                    }
                }
            }
        };
        this.getForm().items.each(fn);
    },
    initComponent: function() {
        mx.comp.FormPanel.superclass.initComponent.apply(this, arguments);
        var fn = (this.disaleFormElements = function(c) {
            if (!c.rendered && Ext.isArray(c.items)) {
                c.on(
                    'render',
                    function() {
                        fn(this);
                    },
                    c
                );
            } else if (!(c instanceof mx.comp.LinkedBoxSelect) && c.items instanceof Ext.util.MixedCollection) {
                c.items.each(fn);
            } else {
                c.disable();
            }
        });
        this.on({
            scope: this,
            afterlayout: function() {
                if (this.readOnly) {
                    this.getForm().items.each(fn);
                }
            },
        });
    },

    initFields: function() {
        var f = this.form;
        var formPanel = this;

        var fn = function(c) {
            if (c.isFormField && !c.isFieldContainer) {
                f.add(c);
            } else if (c != formPanel) {
                if (c.doLayout) {
                    Ext.applyIf(c, {
                        labelAlign: c.ownerCt.labelAlign,
                        labelWidth: c.ownerCt.labelWidth,
                        itemCls: c.ownerCt.itemCls,
                    });
                }
                if (!c.rendered && Ext.isArray(c.items)) {
                    c.on(
                        'render',
                        function() {
                            fn(this);
                        },
                        c
                    );
                } else if (c.items instanceof Ext.util.MixedCollection) {
                    c.items.each(fn);
                }
            }
        };
        this.items.each(fn);
    },
    onDestroy: function() {
        this.destroyed = true;
        mx.comp.FormPanel.superclass.onDestroy.call(this);
    },
});
Ext.reg('mx-form', mx.comp.FormPanel);
